/**
 * Marks the page while the focus moved by keyboard, because a focus ring is for keyboard
 * navigation only. The `focus-visible` variant of index.css obeys the mark.
 *
 * Chrome also shows its ring when a key is pressed on an element that a click focused. That key
 * leaves the focus where it was, so it sets no mark.
 */

export function trackKeyboardFocus(): () => void {
    const root = document.documentElement;
    let isKeyboard = false;
    const onKeyDown = (event: KeyboardEvent): void => {
        // A shortcut, as a cmd+click, is not navigation.
        if (event.metaKey || event.ctrlKey || event.altKey) {
            return;
        }
        isKeyboard = true;
    };
    const onPointerDown = (): void => {
        isKeyboard = false;
        delete root.dataset.keyboardFocus;
    };
    const onFocusIn = (): void => {
        if (isKeyboard) {
            root.dataset.keyboardFocus = '';
        }
    };
    document.addEventListener('keydown', onKeyDown, true);
    document.addEventListener('pointerdown', onPointerDown, true);
    document.addEventListener('focusin', onFocusIn, true);
    return (): void => {
        document.removeEventListener('keydown', onKeyDown, true);
        document.removeEventListener('pointerdown', onPointerDown, true);
        document.removeEventListener('focusin', onFocusIn, true);
        delete root.dataset.keyboardFocus;
    };
}
